import React, { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../pages/app/protected/firebase'; // or adjust to /firebase
import { useNavigate } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';

export default function ProtectedAdmin() {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      const adminUIDs = import.meta.env.VITE_ADMIN_UIDS?.split(',') || [];
  
      if (user && adminUIDs.includes(user.uid)) {
        setAuthenticated(true);
      } else {
        auth.signOut();
        navigate('/');
      }
  
      setLoading(false);
    });
  
    return () => unsubscribe();
  }, [navigate]);

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center">
        <p>Loading...</p>
      </div>
    );
  }

  return authenticated ? (
    <div className="flex">
      <AdminSidebar />
      <main className="flex-1 bg-gray-100 min-h-screen p-6">
        <Outlet />
      </main>
    </div>
  ) : null;
}